export const config = window.lgConfig;

interface ConfigWindow extends Window {
    lgConfig: Config;
}

declare const window: ConfigWindow;

interface Config {
    readonly releaseId: string;
    readonly deployEnvironment: string;
    readonly sentryClassroomFeDsn: string;
    readonly sentryFrontendDsn: string;
    readonly sentryTunnelEndpoint: string | undefined;
    readonly kinesisCognitoIdentityId: string;
    readonly kinesisEndpoint: string;
    readonly kinesisRegion: string;
    readonly matomoUrl: string;
    readonly kameleoonSiteCode: string;
    readonly kameleoonNetworkDomain: string;
    readonly stripePublishable: string;
    readonly facebookAppId: string;
    readonly brazeApiKey: string;
    readonly brazeEndpoint: string;
    readonly mercurePublicUrl: string;
    readonly googleTagManagerId: string;
    readonly classroomGoogleTagManagerId: string;
    readonly teacherFrontendGoogleTagManagerId: string;
    readonly everflowTrackingDomain: string;
    readonly everflowAdvertiserId: string;
    readonly googleRecaptchaV3SiteKey: string;
    readonly presentationModeEndpoint: string;
    readonly presentationModeRestEndpoint: string;
    readonly statisticsEndpoint: string;
    readonly statisticsApiKey: string;
    readonly logEndpoint: string;
    readonly logApiKey: string;
    readonly lingobotGraphqlUrl: string;
    readonly quizEngineEndpoint: string;
    readonly lingophoneWsUrl: string;
    readonly domains: {
        readonly en_TEACHER: string;
        readonly STUDENT: string;
        readonly CLASSROOM_CBE: string;
    };
    readonly mobileAppUrls: {
        readonly ios: string;
        readonly android: string;
        readonly qrcode: string;
    };
}
